// The main menu's tabs: Bhop (built-in maps, the default), Player maps (published builder maps), Map
// Builder, CS:S maps (GameBanana maps and map files) and Settings. The last tab picked is remembered.

export type MenuTab = 'bhop' | 'maps' | 'builder' | 'community' | 'settings';

const KEY = 'bhop-web-menu-tab';
const TABS: readonly MenuTab[] = ['bhop', 'maps', 'builder', 'community', 'settings'];

export class MenuTabs {
  /** Called the first time a tab is opened (lists load then). */
  onOpen: (tab: MenuTab) => void = () => {};
  current: MenuTab = 'bhop';
  private readonly opened = new Set<MenuTab>();
  private readonly buttons: HTMLButtonElement[];
  private readonly panes: HTMLElement[];

  constructor() {
    this.buttons = [...document.querySelectorAll<HTMLButtonElement>('#menuTabs [data-tab]')];
    this.panes = [...document.querySelectorAll<HTMLElement>('#home [data-pane]')];
    for (const b of this.buttons) b.addEventListener('click', () => this.show(b.dataset.tab as MenuTab));
    // Arrow keys move between tabs (the usual tab-list keyboard behaviour).
    document.getElementById('menuTabs')!.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      const i = TABS.indexOf(this.current);
      const next = TABS[(i + (e.key === 'ArrowRight' ? 1 : TABS.length - 1)) % TABS.length];
      this.show(next);
      this.buttons.find((b) => b.dataset.tab === next)?.focus();
      e.preventDefault();
    });
    let saved: string | null = null;
    try {
      saved = localStorage.getItem(KEY);
    } catch {
      // Storage blocked: start on the first tab.
    }
    this.show(TABS.includes(saved as MenuTab) ? (saved as MenuTab) : 'bhop');
  }

  show(tab: MenuTab) {
    this.current = tab;
    for (const b of this.buttons) {
      const on = b.dataset.tab === tab;
      b.classList.toggle('on', on);
      b.setAttribute('aria-selected', String(on));
      b.tabIndex = on ? 0 : -1;
    }
    for (const p of this.panes) p.hidden = p.dataset.pane !== tab;
    try {
      localStorage.setItem(KEY, tab);
    } catch {
      // Not remembered; fine.
    }
    if (!this.opened.has(tab)) {
      this.opened.add(tab);
      this.onOpen(tab);
    }
  }
}
